import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { api, errMsg } from "../lib/api";
import { useT } from "../lib/i18n";
import { Field } from "../components/Common";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const { t } = useT();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), password });
      toast.success("Password updated");
      nav("/login");
    } catch (err) {
      setError(errMsg(err));
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="reset-form">
        <h1 className="text-3xl font-bold">{t("new_password")}</h1>
        <Field label={t("new_password")}>
          <Input data-testid="reset-password-input" type="password" minLength={8} required value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        {error && <p className="text-sm text-destructive" data-testid="reset-error">{error}</p>}
        <Button data-testid="reset-submit-button" className="w-full rounded-full">{t("save")}</Button>
      </form>
    </div>
  );
}
